/** Presentation only: never infer an actor or a missing historical classification. */
export function formatBillingAuditActor(log: { userId: number | null; userName?: string | null }): string {
  const name = log.userName?.trim();
  if (name) return name;
  return log.userId != null ? `usuario #${log.userId}` : "Actor no registrado";
}

export function formatRetentionAuditDetails(action: string, details: unknown): string[] {
  if (!action.startsWith("retention_") || !details || typeof details !== "object") return [];
  const record = details as Record<string, unknown>;
  const date = (value: unknown) => typeof value === "string" && value ? value : "Sin fecha";
  const classification = (value: unknown) => value === true ? "Sí" : value === false ? "No" : "No registrado";
  if (action === "retention_updated") {
    const previous = record.previous && typeof record.previous === "object" ? record.previous as Record<string, unknown> : {};
    const current = record.current && typeof record.current === "object" ? record.current as Record<string, unknown> : {};
    return [
      `Retención: ${classification(previous.isRetention)} → ${classification(current.isRetention)}`,
      `Fecha prevista: ${date(previous.dueDate)} → ${date(current.dueDate)}`,
    ];
  }
  return [
    ...(typeof record.isRetention === "boolean" ? [`Retención: ${classification(record.isRetention)}`] : []),
    ...(typeof record.dueDate === "string" ? [`Fecha prevista: ${date(record.dueDate)}`] : []),
  ];
}
